import { render, staticRenderFns } from "./RegionsTable.vue?vue&type=template&id=568c5c76&scoped=true&"
import script from "./RegionsTable.vue?vue&type=script&lang=ts&"
export * from "./RegionsTable.vue?vue&type=script&lang=ts&"
import style0 from "./RegionsTable.vue?vue&type=style&index=0&id=568c5c76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568c5c76",
  null
  
)

/* custom blocks */
import block0 from "./RegionsTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports